import React from "react";
// reactstrap components
import { Card, CardBody, CardTitle, Row, Col } from "reactstrap";

const Cards = ({ totalPrice, patientCount, totalMonthPrice, monthPatientsCount }) => {
  const { role } = JSON.parse(window.sessionStorage.getItem("user"));
  return (
    <Row className="d-flex justify-content-center">
      <Card
        className="card-stats mb-4 mb-lg-2 col-4 p-2 mr-2 "
        style={{
          flex: "1 1 250px",
          minWidth: "350px",
        }}
      >
        <CardBody>
          <Row>
            <div className="col">
              <CardTitle className="text-uppercase text-muted mb-0">
                Total Price
              </CardTitle>
              <span className="h2 font-weight-bold mb-0">{totalPrice}</span>
            </div>
            <Col className="col-auto">
              <div className="icon icon-shape bg-danger text-white rounded-circle shadow">
                <i className="fas fa-chart-bar" />
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>

      <Card
        className="card-stats mb-4 mb-lg-2 col-4 p-2 mr-2"
        style={{
          flex: "1 1 250px",
          minWidth: "350px",
        }}
      >
        <CardBody>
          <Row>
            <div className="col">
              <CardTitle className="text-uppercase text-muted mb-0">
                Patient Count
              </CardTitle>
              <span className="h2 font-weight-bold mb-0">{patientCount}</span>
            </div>
            <Col className="col-auto">
              <div className="icon icon-shape bg-danger text-white rounded-circle shadow">
                <i className="fa fa-user-injured" />
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>

      <Card
        className="card-stats mb-4 mb-lg-2 col-4 p-2"
        style={{
          flex: "1 1 250px",
          minWidth: "350px",
        }}
      >
        <CardBody>
          <Row>
            <div className="col">
              <CardTitle className="text-uppercase text-muted mb-0">
                monthly price
              </CardTitle>
              <span className="h2 font-weight-bold mb-0">{role.type === "admins" ? totalMonthPrice : "Locked"}</span>
            </div>
            <Col className="col-auto">
              <div className="icon icon-shape bg-danger text-white rounded-circle shadow">
                <i className="fas fa-chart-bar" />
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>

      {role.type === "admins" ? 
      <Card
        className="card-stats mb-4 mb-lg-2 col-4 p-2"
        style={{
          flex: "1 1 250px",
          minWidth: "350px",
        }}
      >
        <CardBody>
          <Row>
            <div className="col">
              <CardTitle className="text-uppercase text-muted mb-0">
                Month Patients Count
              </CardTitle>
              <span className="h2 font-weight-bold mb-0">{role.type === "admins" ? monthPatientsCount : "Locked"}</span>
            </div>
            <Col className="col-auto">
              <div className="icon icon-shape bg-danger text-white rounded-circle shadow">
                <i className="fas fa-chart-bar" />
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>

       : "" }
       
    </Row>
  );
};

export default Cards;
